import { FC, useEffect, useState } from "react";
import { OrderAddress } from "../../contexts/OrderContext";
import styles from "./index.module.css";
import { cepToMask } from "../../functions/mask";
import { usePluginspace } from "../../hooks/usePluginspace";
import { floatToPriceWithoutSpace } from "../../functions/price_functions";

type Props = {
  orderAddress: OrderAddress;
  type: string;
  freight: number;
  config: any;
};

const InfoAddressOrder: FC<Props> = ({
  orderAddress,
  type,
  freight,
  config,
}) => {
  const { pluginspace } = usePluginspace();
  const [labelFree, setLabelFree] = useState("");

  useEffect(() => {
    getConfigLabelFree();
  }, []);

  async function getConfigLabelFree() {
    if (config?.content?.pdv?.customDeliveryFreeLabel)
      setLabelFree(config.content.pdv.customDeliveryFreeLabel);
  }

  return (
    <div className={styles.content}>
      <h4>Forma de entrega</h4>
      <div className={styles.address_order_details}>
        {type === "withdraw" ? (
          <span className={styles.address_order_info}>
            Retirada na Loja -{" "}
            {freight === 0 && labelFree
              ? labelFree
              : floatToPriceWithoutSpace(freight)}
          </span>
        ) : (
          <span className={styles.address_order_info}>
            Entrega -{" "}
            {freight === 0 && labelFree
              ? labelFree
              : floatToPriceWithoutSpace(freight)}
          </span>
        )}

        <span>{orderAddress?.extra}</span>
        <span>
          {orderAddress?.address},{orderAddress?.number}
        </span>
        <span>
          {orderAddress?.district},{orderAddress?.city} - {orderAddress?.state}{" "}
          {cepToMask(orderAddress?.cep ? orderAddress?.cep : "")}
        </span>

        {/* Info da Loja */}
        {type === "withdraw" && (
          <div>
            <span> {pluginspace.phoneContact}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export { InfoAddressOrder };
